import React from "react";
import "./style.css";

export default function BreadCrumb() {
  return (
    <div className="article__big">
      <div className="breadcrumb">
        <ol vocab="https://schema.org/" typeof="BreadcrumbList">
          <li property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              href="https://versus-clone.com/"
            >
              <span property="name">Home</span>
            </a>
            <meta property="position" content="1" />
          </li>
          ›
          <li property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              href="https://versus-clone.com/phone"
            >
              <span property="name">Smartphone comparison </span>
            </a>
            <meta property="position" content="2" />
          </li>
          ›
          <li property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              href={`https://versus-clone.com/OnePlus-8-Pro`}
            >
              <span property="name">{`OnePlus 8 Pro`}</span>
            </a>
            <meta property="position" content="3" />
          </li>
        </ol>
      </div>
    </div>
  );
}
